module.exports = __webpack_public_path__ + "static/img/121.8ebed63.png";